import { AttributeGroupDTO, AttributeGroupValueDTO } from "@touche-lts/panel-ui/dist";

export enum StoresSortBy {
    TOPRATED = 'Top rated first',
    LESSRATED = 'Less rated'
}

export interface StoreAttributes extends AttributeGroupDTO {
    expanded: boolean;
    values: StoreAttributeValues[]
}

export interface StoreAttributeValues extends AttributeGroupValueDTO {
    checked: boolean;
}